// Constants for the prompt-tuning admin UI. These mirror the backend's
// `ClientCompanyConfigValueKey`, `PromptProposal.Status`, and
// `PromptFeedbackTriageEntry.Status`/`ExclusionReason` choices — keep in sync
// when adding values on the backend.

export const CONFIG_KEYS = [
  { value: "pa_autocomplete_prompt", label: "Autocomplete" },
  { value: "pa_autocomplete_prompt_fax", label: "Autocomplete (fax)" },
  { value: "pa_primary_diagnosis_prompt", label: "Primary diagnosis" },
];

export const CONFIG_KEY_VALUES = CONFIG_KEYS.map((k) => k.value);

const CONFIG_KEY_LABEL_BY_VALUE = Object.fromEntries(CONFIG_KEYS.map((k) => [k.value, k.label]));

export function configKeyLabel(value) {
  return CONFIG_KEY_LABEL_BY_VALUE[value] || value;
}

export const PROPOSAL_STATUSES = ["PENDING", "LOW_CONFIDENCE", "APPROVED", "APPLIED", "REJECTED"];

export const TRIAGE_STATUSES = ["PENDING", "INCLUDED", "EXCLUDED", "PROCESSED"];

export const EXCLUSION_REASONS = ["FRAUDULENT", "DUPLICATE", "OUT_OF_SCOPE", "NOISY", "OTHER"];

export const TRIAGE_TERMINAL_STATUS = "PROCESSED";

export const PROPOSAL_TERMINAL_STATUSES = new Set(["APPLIED", "REJECTED"]);
